module.exports = __webpack_public_path__ + "img/BlinkArt_Sword8_Gold.dea25b2b.png";